import request from '@/utils/request'
// import store from '@/store'

// 获取微信jsSDK的config签名
export const getJsApiSignApi = () => {
  return request({
    url: `/huijuinterface/huijuApi/getSign`,
    method: 'post',
    data: {
      signUrl: encodeURIComponent(location.href.split('#')[0])
    },
    hideLoading: true,
  })
}

// 微信登录接口
export const loginApi = (data) => {
  return request({
    url: `/huijuinterface/huijuApi/login`,
    method: 'post',
    data,
    hideLoading: true,
    // hideErrMsgToast: true,
  })
}

// 获取微站信息-未登录
export const getSiteInfoApi = data => {
  return request({
    url: `/huijuinterface/homePage/getSiteInfo`,
    method: 'post',
    data,
    hideLoading: true,
  })
}

// 验证码
export const sendCode = (data) => {
  return request({
    url: `/huijuinterface/huijuApi/sendCode`,
    method: 'post',
    data,
    token: sessionStorage.getItem('huijuToken'),
    hideLoading: true,
  })
}
// 绑定手机
export const bindPhone = (data) => {
  return request({
    url: `/huijuinterface/mine/bindPhone`,
    method: 'post',
    data,
    token: sessionStorage.getItem('huijuToken'),
    hideLoading: true,
  })
}
// 精选好物
export const productList = (data) => {
  return request({
    url: `/huijuinterface/homePage/productList`,
    method: "POST",
    data: data,
    token: sessionStorage.getItem('huijuToken'),
    hideLoading: true,
  })
}
// 用户信息
export const userInfoApi = (data) => {
  return request({
    url: `/huijuinterface/mine/userInfo`,
    method: "GET",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
  })
}
// 首页数据-h5用post, 小程序还是get
export const homePageApi = (data) => {
  return request({
    url: `/huijuinterface/homePage`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
  })
}
// 校验商品接口：消费券调用券仓商品库存查询接口查询商品库存
export const checkProductApi = (data) => {
  return request({
    url: `/huijuinterface/shoppingTrolley/checkProduct`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}
// 校验是否可以购买商品

export const checkCanBuyApi = (data) => {
  return request({
    url: `/huijuinterface/riskManage/checkCanBuy`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}
// 下单接口

export const placeorderApi = (data) => {
  return request({
    url: `/huijuinterface/huijuplaceorder/placeorder`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}
// 订单列表
export const getClientOrderListApi = (data) => {
  return request({
    url: `/huijuinterface/huijuplaceorder/clientOrderList`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}

// 再次发起支付
export const ordertoPayApi = (data) => {
  return request({
    url: `/huijuinterface/huijuplaceorder/toPay`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
  })
}

// 收货地址-列表
export const hjUserReceiverInfoListApi = (data) => {
  return request({
    url: `/huijuinterface/hjUserReceiverInfo/list`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}
// 收货地址-添加
export const hjUserReceiverInfoAddApi = (data) => {
  return request({
    url: `/huijuinterface/hjUserReceiverInfo/add`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}
// 收货地址-更新
export const hjUserReceiverInfoUpdateApi = (data) => {
  return request({
    url: `/huijuinterface/hjUserReceiverInfo/update`,
    method: "POST",
    token: sessionStorage.getItem('huijuToken'),
    data: data,
    hideLoading: true,
  })
}